export interface ServiceDetails {
  howItWorks: string[]
  includes: string[]
  notes: string[]
  afterRequest: string | null
}

export const emptyServiceDetails = (): ServiceDetails => ({
  howItWorks: [],
  includes: [],
  notes: [],
  afterRequest: null,
})

export const hasServiceDetailsContent = (
  details: ServiceDetails | null | undefined,
): boolean => {
  if (!details) return false
  return (
    details.howItWorks.length > 0 ||
    details.includes.length > 0 ||
    details.notes.length > 0 ||
    Boolean(details.afterRequest?.trim())
  )
}
